// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { AuthProvider, useAuth } from './auth/AuthContext';
import RequireAuth from './auth/RequireAuth';
import RequireAdmin from './auth/RequireAdmin';
import LoginPage from './auth/LoginPage';
import UsersPage from './users/UsersPage';
import HomePage from './HomePage';  // Import the home page
import NflPage from './streaming/NflPage';  // Import the NFL page
import NflGame from './streaming/NflGame';  // Import the NFL game page
import MotorsportsPage from './streaming/MotorsportsPage';
import MotorsportsEvent from './streaming/MotorsportsEvent';
import LiveTvPage from './streaming/LiveTvPage';
import LiveTvStream from './streaming/LiveTvStream';
import DevicesPage from './device/DevicesPage';  // Import the devices page
import NewDevicePage from './device/NewDevicePage';
import EditDevicePage from './device/EditDevicePage';
import EpgPage from './epg/EpgPage';  // Import the EPG page
import nostratvLogo from './assets/nostratv-logo.svg';

function AppContent() {
  const { user, logout } = useAuth();

  return (
      <>
        {/* Navbar with Menu Options */}
        <Navbar variant="dark" expand="lg" className="site-navbar">
          <Navbar.Brand as={Link} to="/" className="site-brand">
            <img src={nostratvLogo} alt="" aria-hidden="true" />
            <span>NOStraTV</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {user && <Nav.Link as={Link} to="/devices">Devices</Nav.Link>}
              {user && <Nav.Link as={Link} to="/epg">EPG</Nav.Link>}
              {user?.role === 'admin' && <Nav.Link as={Link} to="/users">Users</Nav.Link>}
              <NavDropdown title="Streaming" id="basic-nav-dropdown">
                <NavDropdown.Item as={Link} to="/streaming/nfl">NFL</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/streaming/motorsports">Motorsports</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/streaming/livetv">Live TV</NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <Nav>
              {user ? (
                <button type="button" onClick={logout} className="nav-link btn btn-link">Sign out</button>
              ) : (
                <Nav.Link as={Link} to="/login">Sign in</Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        {/* Routes Definition */}
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<HomePage />} />  {/* Home Page */}
          <Route path="/streaming/nfl" element={<RequireAuth><NflPage /></RequireAuth>} />
          <Route path="/streaming/nfl/game/:gameId" element={<RequireAuth><NflGame /></RequireAuth>} />
          <Route path="/streaming/motorsports" element={<RequireAuth><MotorsportsPage /></RequireAuth>} />
          <Route path="/streaming/motorsports/event/:gameUrl" element={<RequireAuth><MotorsportsEvent /></RequireAuth>} />
          <Route path="/streaming/livetv" element={<RequireAuth><LiveTvPage /></RequireAuth>} />
          <Route path="/streaming/livetv/event/:gameUrl" element={<RequireAuth><LiveTvStream /></RequireAuth>} />
          <Route path="/devices" element={<RequireAuth><DevicesPage /></RequireAuth>} />  {/* Devices Page */}
          <Route path="/epg" element={<RequireAuth><EpgPage /></RequireAuth>} />  {/* EPG Page */}
          <Route path="/epg/:deviceName" element={<RequireAuth><EpgPage /></RequireAuth>} />  {/* EPG for a specific device */}
          <Route path="devices/create" element={<RequireAdmin><NewDevicePage /></RequireAdmin>} />  {/* Create Device Page */}
          <Route path="devices/edit/:deviceName" element={<RequireAdmin><EditDevicePage /></RequireAdmin>} />  {/* Edit Device Page */}
          <Route path="/users" element={<RequireAdmin><UsersPage /></RequireAdmin>} />
          {/* You can add other routes like Devices, F1, Live TV here */}
        </Routes>
      </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
